import { render, staticRenderFns } from "./BomInfo.vue?vue&type=template&id=2110ceb4&scoped=true"
import script from "./BomInfo.vue?vue&type=script&lang=js"
export * from "./BomInfo.vue?vue&type=script&lang=js"
import style0 from "./BomInfo.vue?vue&type=style&index=0&id=2110ceb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2110ceb4",
  null
  
)

export default component.exports